<template>
    <div class="form-group">
        <div v-if="infoText" class="d-flex align-items-center">
            <label v-if="label" class="mr-1">{{ label }}</label>
            <InfoToolTip v-if="infoText" :info="infoText" class="pb-1" />
        </div>

        <label v-if="label && !infoText">
            {{ label }}
            <span v-if="ejemplo" style="color: inherit; font-weight: normal;">{{ ejemplo }}</span>
        </label>

        <ValidationProvider :name="name" :rules="rules" v-bind="providerProps" v-slot="{ errors }">
            <div class="position-relative">
                <input
                    v-model="hidden_value"
                    @input="handleInput"
                    @change="handleChange"
                    :placeholder="placeholder || label"
                    :maxlength="maxlength"
                    v-bind="$attrs"
                    class="form-control w-100"
                    :class="{'is-invalid': errors[0], 'dni-front': front, 'pr-2': quitar_pr, 'pr-5': !quitar_pr}"
                />
                <span v-if="maxlength" class="char-counter">
                    {{ hidden_value.length }}/{{ maxlength }}
                </span>
            </div>
            <span v-if="errors[0]" :class="{ 'dni-front': front }" :data-cy="'error-validacion-' + name" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;">
                <b>{{ errors[0].charAt(0).toUpperCase() + errors[0].slice(1).toLowerCase() }}</b>
            </span>
            <span v-if="apiValidationError" :class="{ 'dni-front': front }" :data-cy="'error-validacion-' + name" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;">
                <b>{{ Array.isArray(apiValidationError) ? apiValidationError.join(', ') : apiValidationError }}</b>
            </span>
        </ValidationProvider>
    </div>
</template>

<script setup>
    import { ref, computed, watch } from 'vue';
    import InfoToolTip from '@/components/common/InfoToolTip';

    const props = defineProps({
        label: String,
        rules: [String, Object],
        name: String,
        value: [ String, Number ],
        apiValidationError: [String, Array],
        placeholder: String,
        infoText: String,
        front: Boolean,
        vid: String,
        maxlength: [String, Number],
        ejemplo: String,
        quitar_pr: Boolean
    });

    const emit = defineEmits(['input', 'change']);

    const hidden_value = ref(props.value != null ? String(props.value) : '');

    const providerProps = computed(() => {
        return props.vid ? { vid: props.vid } : {};
    });

    const handleInput = e => {
        emit('input', e.target.value);
    };

    const handleChange = e => {
        emit('change', e.target.value);
    };

    watch(() => props.value, newValue => {
        hidden_value.value = newValue || '';
    });
</script>

<script>
    export default {
        inheritAttrs: false
    };
</script>


<style scoped>
    .dni-front {
        width: 80%;
    }

    .position-relative {
        position: relative;
    }

    .char-counter {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 12px;
        color: #AAAAAA;
        font-weight: bold;
        background: white;
        padding: 2px 5px;
        border-radius: 4px;
    }
</style>
